import _ from 'lodash-es';
import APIV5 from '~/models/api';
import FileDownload from '../../scripts/services/model/file-download';

export class FileDownloadServiceModel {
	/** @type {FileDownload[]} */
	#files;

	/** @type {?import('angular').ui.bootstrap.IModalInstanceService} */
	#modalInstance;

	/* @ngInject */
	/**
	 * @param {import('angular').auto.IInjectorService} $injector
	 */
	constructor($injector) {
		this.$injector = $injector;
		this.$filter = this.$injector.get('$filter');
		this.$translate = this.$injector.get('$translate');

		this.#files = [];
		this.#modalInstance = null;
	}

	clean() {
		_.remove(this.#files, file => file.downloaded === file.size);
	}

	/**
	 *
	 * @param {any[]} items
	 * @returns {Promise<FileDownload | undefined>}
	 */
	async prepare(items) {
		this.clean();

		if (items.length > 1) {
			const fileDownload = new FileDownload(this.$injector);
			fileDownload.compressing = true;
			fileDownload.name = this.$filter('sprintf')(this.$translate.instant('list.compressing-files'), items.length);
			this.#files.push(fileDownload);

			const result = await APIV5.instance.compressZipCreateFromNodeList(
				{ nodelist: items.map(item => item.getData().kid) },
				{ id: 'download-service.prepare' },
			);
			if (result) {
				fileDownload.compressing = false;
				fileDownload.kid = result.fileid;
				return fileDownload;
			}
			return undefined;
		}
		if (items.length === 1) {
			const file = new FileDownload(this.$injector, items[0]);
			this.#files.push(file);
			return file;
		}
		return undefined;
	}

	/**
	 * @param {any[]} items
	 * @param {string} [target]
	 * @returns {Promise<any>}
	 */
	async download(items, target = '_self') {
		const file = await this.prepare(items);
		return file ? this.launchDownload(file, target) : undefined;
	}

	/**
	 * @param {FileDownload} file
	 * @param {string} [target]
	 */
	launchDownload(file, target = '_self') {
		const options = {
			endpointVersion: 2,
		};

		// @ts-ignore
		if (this.$injector.get('$rootScope').kds) {
			options.endpointVersion = 3;
		}

		const url = APIV5
			.instance
			.downloadURL({
				nodeid: file.kid,
			}, options);
		window.open(url, target);
	}
}

const fileDownloadService = /* @ngInject */ (
	/** @type {import("angular").auto.IInjectorService} */ $injector,
) => new FileDownloadServiceModel($injector);

export default fileDownloadService;
